import * as React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import LogoutIcon from "@mui/icons-material/Logout";
import { MainListItems } from "../Dashboard/listItems";
import { Outlet, useNavigate } from "react-router-dom";
import { logoutUser } from "../../Features/slice/userSlice";
import { useAppDispatch } from "../../Hooks/reduxHook";
import { LocalImage } from "Utils/images";
import { Colors } from "Utils/colors";
import { Container, Stack, Badge, Button } from "@mui/material";
import CurrentUser from "Screens/Dashboard/CurrentUser";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";

const drawerWidth: number = 240;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));
const defaultTheme = createTheme();

function Layout() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [open, setOpen] = React.useState(true);

  const onClickLogout = () => {
    dispatch(logoutUser(""));
    navigate("/signin");
  };



  return (
    <ThemeProvider theme={defaultTheme}>
      <Box
        sx={{ display: "flex", bgcolor: Colors.primary, height: "100vh" }}
        className="WGF-left-section"
      >
        <CssBaseline />

        <Drawer variant="permanent" open={open} style={{ height: "100vh" }}>
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              px: [3],
            }}
          >
            <Box
              component="img"
              alt="Your logo."
              src={LocalImage.newLogo}
              sx={{
                width: 'auto',
                height: 'auto',
                maxWidth: '100%',
                maxHeight: '100%',
                pl: 0,
                pr: 0,
                mx: 'auto',
                display: 'block'
              }}
              // style={{width:'12vw', height:'4vw',}}
            // onClick={toggleDrawer}
            />
          </Toolbar>
          {/* <Divider /> */}
          <CurrentUser />
          
          {/* <Box sx={{ display: "flex", py: 2, mt: 1, justifyContent: "center" }}>
            <Stack direction="row" spacing={3} color={Colors.white}>
              <NoteAddOutlinedIcon />
              <SettingsOutlinedIcon />
              <Badge badgeContent={12} color="secondary" sx={{ "& .MuiBadge-badge": { color: "#FFF", backgroundColor: "#FFAA2A" } }}>
                <NotificationsNoneIcon />
              </Badge>
            </Stack>
          </Box> */}
          
          <List
            component="nav"
            sx={{ color: "#fff", mt: 2 }}
            className="main-menu-list"
          >
            <MainListItems onClick={(value) => navigate(value)} />
          </List>
          <Container
            sx={{
              width: "100%",
              position: "absolute",
              bottom: 50,
              color: Colors.white,
            }}
          >
            <Box className="user-logout">
              <Button onClick={onClickLogout} variant="outlined">
                <LogoutIcon /> &nbsp;Logout
              </Button>
            </Box>
          </Container>
        </Drawer>
        <Outlet />
      </Box>
    </ThemeProvider>
  );
}

export default Layout;
